import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * What the dashboard shows somebody who signed in successfully and belongs to no group. No table, because a
 * set of column headers over an explanation is a table pretending to be one: only a person can resolve this,
 * so the page says who to write to and offers the one page that works without a group.
 */
export function NoGroupNotice({ supportEmail }: { supportEmail: string }) {
  const { t } = useTranslation();
  const address = supportEmail.trim();

  return (
    <div className="card empty-state no-group">
      <i className="pi pi-users" aria-hidden="true" />
      <h2>{t('dashboard.noGroupTitle')}</h2>
      <p className="hint">{t('dashboard.noGroupYet')}</p>

      {/* Nothing offered when the installation has configured no address: see Support:Email. */}
      {address && (
        <p className="no-group__ask">
          {t('dashboard.requestAccess')}{' '}
          <a href={`mailto:${address}?subject=${encodeURIComponent(t('dashboard.requestAccessSubject'))}`}>
            {address}
          </a>
        </p>
      )}

      <Link to="/vcard" className="btn btn-primary">
        <i className="pi pi-id-card me-2" aria-hidden="true" />
        {t('dashboard.goToContactCard')}
      </Link>
    </div>
  );
}
